import {
  Chat,
  Message,
  ChatHistory,
  ChatState,
  SendMessageReq,
  SendMessageRes,
  ChatTurnResult,
  GetChatResponseItem,
  ResumeHitlReq,
} from "../type/chat";
import { parseAsyncJobInterrupt, parseRagTurnResult } from "./rag-response";

export class ChatAdapter {
  static toOutputDTO(data: ChatHistory[]): Chat[] {
    return data.map((item) => ({
      id: item.chat_id,
      title: item.title,
    }));
  }

  static toChatOutputDTO(data: ChatState, chatId: string): Message[] {
    // ChatStateから実際のチャットメッセージを抽出する
    // API仕様: 番号をキーとした辞書形式 { "1": {...}, "2": {...} }

    if (!data || Object.keys(data).length === 0) {
      return [];
    }

    const messages: Message[] = [];

    for (const [key, messageData] of Object.entries(data)) {
      const messageNumber = parseInt(key);
      if (isNaN(messageNumber)) continue;

      if (messageData && typeof messageData === "object") {
        const request = (messageData as any).request;
        const response = (messageData as any).response;
        if (request) {
          let output = "";
          if (!response || Object.keys(response).length === 0 || !response.output) {
            output = "メッセージが取得できませんでした。";
          } else {
            output = response.output;
          }
          const turn = messageData as GetChatResponseItem;
          messages.push({
            id: messageNumber,
            chatId: chatId,
            chatNo: messageNumber,
            query: request.query || "",
            output: output,
            figure: response?.figure,
            used_tools: response?.used_tools,
            modelId: request.model_id,
            newModelId: response?.next_model_id,
            queriedModelId: response?.queried_model_id,
            artifactUrls: response?.artifact_urls,
            turnDisplay: response?.turn_display,
            asyncJob: parseAsyncJobInterrupt(turn.async_job),
            sourceTaskId: turn.source_task_id ?? undefined,
          });
        }
      }
    }

    messages.sort((a, b) => a.chatNo - b.chatNo);

    return messages;
  }

  static toInputDTO(req: {
    chatId: string;
    chatNo: number;
    query: string;
    modelId: string;
    mode: string;
    files?: File[];
  }): SendMessageReq {
    return {
      chat_id: req.chatId,
      chat_no: req.chatNo,
      query: req.query,
      model_id: req.modelId,
      tool_execution_role: req.mode,
      files: req.files,
    };
  }

  static toAddChatOutputDTO(data: SendMessageRes): ChatTurnResult {
    return parseRagTurnResult(data);
  }

  static toResumeHitlInputDTO(req: {
    chatId: string;
    modelId: string;
    action: ResumeHitlReq["action"];
    feedback?: string;
    runId?: string;
  }): ResumeHitlReq {
    return {
      chat_id: req.chatId,
      model_id: req.modelId,
      action: req.action,
      feedback: req.feedback,
      run_id: req.runId,
    };
  }
}
